import { cn } from '../../lib/utils';

/**
 * Mediafy / MAMS logo mark — geometric "M" formed by overlapping diamonds in brand blue.
 * sizes: xs=20, sm=24, md=32, lg=40, xl=48
 */
export function LogoMark({ className, size = 'md' }) {
  const px = { xs: 20, sm: 24, md: 32, lg: 40, xl: 48 }[size] || 32;
  return (
    <div
      className={cn(
        'flex items-center justify-center bg-gradient-to-br from-brand-500 to-brand-700 text-white shadow-md shadow-brand-600/20',
        size === 'xs' && 'rounded-md',
        size === 'sm' && 'rounded-md',
        size === 'md' && 'rounded-lg',
        size === 'lg' && 'rounded-lg',
        size === 'xl' && 'rounded-xl',
        className,
      )}
      style={{ width: px, height: px }}
    >
      <svg viewBox="0 0 24 24" fill="none" width={px * 0.62} height={px * 0.62} aria-hidden="true">
        <path d="M3 12L9 6L12 9L15 6L21 12L15 18L12 15L9 18L3 12Z" fill="currentColor" opacity="0.95"/>
        <path d="M9 12L12 9L15 12L12 15L9 12Z" fill="white" opacity="0.95"/>
      </svg>
    </div>
  );
}

/**
 * Full logo lockup: mark + wordmark.
 */
export function LogoLockup({ className, size = 'md', subtitle = 'by Mediafy' }) {
  const titleSize = { sm: 'text-sm', md: 'text-[15px]', lg: 'text-lg', xl: 'text-xl' }[size] || 'text-[15px]';
  const subSize   = { sm: 'text-2xs', md: 'text-2xs', lg: 'text-xs', xl: 'text-xs' }[size] || 'text-2xs';
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <LogoMark size={size} />
      <div className="leading-tight">
        <div className={cn('font-bold text-ink-900 dark:text-ink-50 tracking-tighter', titleSize)}>MAMS</div>
        {subtitle && (
          <div className={cn('uppercase font-semibold text-ink-400 dark:text-ink-500 tracking-[0.08em]', subSize)}>
            {subtitle}
          </div>
        )}
      </div>
    </div>
  );
}

export default LogoLockup;
